<button
  [type]="type"
  [disabled]="disabled || loading"
  [class]="'custom-btn variant-' + variant + ' size-' + size + (fullWidth ? ' full-width' : '')"
  (click)="onClick($event)"
  >
  @if (loading) {
    <span class="loading-spinner"></span>
  }
  @if (icon && !loading) {
    <i [class]="icon"></i>
  }
  <span class="btn-content">
    <ng-content></ng-content>
  </span>
</button>
